import React, { Fragment } from 'react';
import PropTypes from 'prop-types';

import { CloseOutlined } from '@ant-design/icons';

import config from '@config';

import MainTitle from '@views/MainTitle';
import MainMenu from '@views/MainMenu';

import { Button } from 'antd';
import { eventHandler, GAAction } from '@analytics';

import './AppHeader.css';

const align = (side) => ({ textAlign: side });

const AppHeader = ({ shareMode }) => {
  const [isMobileMenuOpen, setIsMobileMenuOpen] = React.useState(false);
  return (
    <div id="AppHeader">
      <div className="header-title">
        <MainTitle />
      </div>
      {shareMode ? (
        <div
          style={{ ...align('right'), overflow: 'hidden' }}
          className="header-join-from-share"
        >
          <Button
            type="primary"
            onClick={eventHandler(GAAction.JoinZarFromShare)}
            href={`${config.host}${config.basePath}`}
            target="_blank"
            style={{ marginRight: '40px' }}
          >
            Empezá a Jugar
          </Button>
        </div>
      ) : (
        <Fragment>
          <div className="header-mobile-menu" style={align('left')}>
            <a
              className="ant-dropdown-link"
              onClick={() => {
                setIsMobileMenuOpen(true);
              }}
            >
              <img
                src={`${config.basePath}/img/mobile-menu.png`}
                alt="Abrir menú"
                className="mobile-menu-trigger-icon"
              />
            </a>

            <div
              className={`mobile-menu ${
                isMobileMenuOpen ? 'mobile-menu-open' : ''
              }`}
            >
              <div className="mobile-menu-header">
                <div className="mobile-menu-logos">
                  <img
                    className="mobile-menu-pagina12-logo"
                    src={`${config.basePath}/img/p12logo-light.svg`}
                    alt="Logo de Página 12"
                  />
                </div>
                <a
                  onClick={() => {
                    setIsMobileMenuOpen(false);
                  }}
                >
                  <CloseOutlined size="big" />
                </a>
              </div>
              <MainMenu
                mode="vertical"
                onLinkClick={() => {
                  setIsMobileMenuOpen(false);
                }}
              />
            </div>
          </div>
          <div className="header-mobile-right-logo">
            <img
              src={`${config.basePath}/img/p12logo-light.svg`}
              alt="Página 12"
            />
          </div>
          <div className="header-main-menu">
            <MainMenu mode="horizontal" />
          </div>
          <div className="header-right-logo">
            <img
              src={`${config.basePath}/img/pagina12-black.png`}
              alt="Página 12"
            />
          </div>
        </Fragment>
      )}
    </div>
  );
};

AppHeader.displayName = 'AppHeader';
AppHeader.propTypes = {
  shareMode: PropTypes.bool,
};
AppHeader.defaultProps = {
  shareMode: false,
};

export default AppHeader;
